<div class="grid" style="margin-top: 8px;">
  <div class="col-12 xl:col-5">
    <div class="card main-height">
      <div class="card-header pt-1">
        <div>
          <h4 class="mb-1">{{'misc.overview.assetLocation' | transloco}}
            <a class="underline" *ngIf="asset" [routerLink]="'/assets/' + asset.uuid + '/details'">
              ({{asset.alias}})
            </a>
          </h4>
        </div>
<!--        <div *ngIf="!asset" [style.height]="'18px'" class="w-full p-3">-->
<!--          <p-skeleton class="bold" width="100%" height="1em"></p-skeleton>-->
<!--        </div>-->
      </div>
      <hr>
      <div *ngIf="!loadedMap">
        <app-table-skeleton></app-table-skeleton>
      </div>
      <div id="map" class="rounded" *ngIf="asset"
           [style.display]="!loadedMap ? 'none' : 'block'"></div>
      <div
        *ngIf="!asset && !loadingAssetDevices"
        [style.height]="'320px'"
        class="flex justify-content-center align-items-center"
      >
        <p class="text-xl font-italic">{{'empty.asset' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12 xl:col-4">
    <div class="card main-height">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.deviceInfo' | transloco}}</h4></div>
      <hr>
      <table class="details-table striped-table" *ngIf="device">
        <tr>
          <td class="p-3 bold">{{'attribute.uuid' | transloco}}</td>
          <td class="pr-1">
            <app-clipboard-label [value]="device.uuid" [copiedValue]="device.uuid"></app-clipboard-label>
          </td>
        </tr>
        <tr *ngIf="'ROLE_SUPER_ADMIN' | userHasRole">
          <td class="p-3 bold">{{'model.tenant' | transloco}}</td>
          <td>
            <a *ngIf="device.tenant"
               [routerLink]="['/management/tenants', device.tenant.uuid, 'details']"
            >
              {{device.tenant.name}}
            </a>
          </td>
        </tr>
        <tr *ngIf="'ROLE_ADMIN' | userHasRole" >
          <td class="p-3 bold">{{'model.organization' | transloco}}</td>
          <td>
            <a *ngIf="device.organization"
               [routerLink]="['/management/organizations', device.organization.uuid, 'details']"
            >
              {{device.organization.name}}
            </a>
          </td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.createdAt' | transloco}}</td>
          <td>{{device.creationAt | customDate}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.timezone' | transloco}}</td>
          <td>{{device.timezone}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'model.category' | transloco}}</td>
          <td>{{device.deviceCategory ? device.deviceCategory.name : ''}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.lastValueReported' | transloco}}</td>
          <td>{{device.dateLastValueReported | customDate}}</td>
        </tr>
        <tr>
          <td class="p-3 bold">{{'attribute.associationDate' | transloco}}</td>
          <td>{{device.associationDate | customDate}}</td>
        </tr>
      </table>
      <app-table-skeleton *ngIf="!device" [striped]="true"></app-table-skeleton>
    </div>
  </div>
  <div class="col-12 xl:col-3">
    <div class="card main-height flex flex-column">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.availableData' | transloco}} </h4></div>
      <hr>
      <div *ngIf="availableData" class="flex flex-column justify-content-center flex-1">
        <div class="text-center">
          <p class="m-0 bold">{{'time.today' | transloco}}</p>
          <p style="font-size: 10px;">{{'misc.statistics.totalSignalsWithData' | transloco}}</p>
          <div [style.font-size]="'40px'">
            <p class="inline" *ngIf="availableData.today <= 0" style="color: #D91E1E;">{{availableData.today}}</p>
            <p class="inline" *ngIf="availableData.today > 0" style="color: var(--primary-color);">{{availableData.today}}</p>
            <p class="inline"> / {{availableData.total}}</p>
          </div>
        </div>
        <div class="text-center mt-4">
          <p class="m-0 bold">{{'time.historyTime' | transloco}}</p>
          <p style="font-size: 10px">{{'misc.statistics.totalSignalsWithData' | transloco}}</p>
          <div [style.font-size]="'40px'">
            <p class="inline" *ngIf="availableData.allTime <= 0" style="color: #D91E1E;">{{availableData.allTime}}</p>
            <p class="inline" *ngIf="availableData.allTime > 0" style="color: var(--primary-color);">{{availableData.allTime}}</p>
            <p class="inline"> / {{availableData.total}}</p>
          </div>
        </div>
        <div class="text-center mt-4">
          <p class="m-0 bold">{{'time.lastCommTime' | transloco}}</p>
          <p style="font-size: 10px">{{'misc.statistics.lastCommDate' | transloco}}</p>
          <div [style.font-size]="'20px'">
            <p class="inline" *ngIf="lastCommunicationFromIntModules <= 0" style="color: #D91E1E;">{{'misc.statistics.not_available' | transloco}}</p>
            <p class="inline" *ngIf="lastCommunicationFromIntModules > 0" style="color: var(--primary-color);">{{lastCommunicationFromIntModules | customDate}}</p>
          </div>
        </div>
      </div>
      <div *ngIf="!availableData">
        <app-table-skeleton></app-table-skeleton>
      </div>
    </div>
  </div>
</div>

<div class="grid" style="margin-top: 2px">
  <div class="col-12 xl:col-6">
    <div class="card main-height">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.integrationInfo' | transloco}} </h4></div>
      <hr>
      <div class="flex flex-column sm:flex-row h-full" style="min-height: 320px;" *ngIf="integrationModules">
        <div class="w-12 sm:w-4">
          <div>
            <p class="bold">{{'model.module' | transloco}}</p>
          </div>
          <div
            *ngFor="let module of integrationModules"
            class="my-3 cursor-pointer module-card"
            [class.module-card-selected]="module === selectedModule"
            (click)="setModuleAdditionalInfo(module)"
          >
            {{module.integrationIdentifier}}
            <p class="code-label inline">({{module.integrationCode}})</p>
          </div>
        </div>
        <div class="w-12 sm:w-8 flex flex-column sm:flex-row">
          <p-divider class="hidden sm:block" layout="vertical"></p-divider>
          <p-divider class="block sm:hidden" layout="horizontal"></p-divider>
          <div>
            <div>
              <p class="bold">{{'misc.overview.integrationInfo' | transloco}}</p>
            </div>
            <div class="mt-3">
              <ngx-json-viewer *ngIf="currentModuleInfo" [json]="currentModuleInfo"></ngx-json-viewer>
              <p class="pt-1" *ngIf="!currentModuleInfo"><i>{{'misc.noInfo' | transloco}}</i></p>
            </div>
          </div>
        </div>
      </div>
      <app-table-skeleton *ngIf="!integrationModules && loadingIntegrationModules"></app-table-skeleton>
      <div
        *ngIf="!integrationModules && !loadingIntegrationModules"
        [style.height]="'320px'"
        class="flex flex-1 justify-content-center align-items-center"
      >
        <p class="text-xl font-italic">{{'empty.integrationModules' | transloco}}</p>
      </div>
    </div>
  </div>
  <div class="col-12 xl:col-6">
    <div class="card main-height">
      <div class="card-header pt-1"><h4 class="mb-1">{{'misc.overview.properties' | transloco}} </h4></div>
      <hr>
      <div
        *ngFor="let property of properties"
        class="flex flex-column sm:flex-row"
        style="border-bottom: 1px solid #DEE2E6;"
      >
        <div class="p-3 flex-1 bold">{{property.name}}</div>
        <div class="p-3 flex-1 sm:text-right">{{property.value}}</div>
      </div>
      <div
        *ngIf="properties && properties.length == 0"
        [style.height]="'320px'"
        class="flex flex-1 justify-content-center align-items-center"
      >
        <p class="text-xl font-italic">{{'empty.properties' | transloco}}</p>
      </div>
      <app-table-skeleton *ngIf="!properties"></app-table-skeleton>
    </div>
  </div>
</div>
